import React, { useEffect, useMemo, useState } from "react";
import { throttle } from "lodash";
import "./ShortCut.scss";

export default function ShortCut(props) {
  // const [ScrollY, setScrollY] = useState(0);
  const [ActiveId, setActiveId] = useState("");
  const [shortCutData, setShortCutData] = useState();
  const [shortCutList, setShortCutList] = useState();

  let idList = [];
  let idPosition = [];

  var browse = navigator.userAgent.toLowerCase();

  function scrollToHash(id) {
    /* Obtain hash from current location (and trim off leading #) */
    // const id = window.location.hash.substr(1);
    if (id) {
      /* Find matching element by id */
      // const anchor = document.getElementById(id);
      var anchor;
      const el = document.querySelectorAll(".manual-item");
      el.forEach((item) => {
        if (item.textContent === id) anchor = item;
      });

      if (anchor) {
        /* Scroll to that element if present */

        //window.scrollTo(0, anchor.offsetTop-80);
        //window.scrollTo({top:anchor.offsetTop-80, behavior:'smooth'});

        if (browse.indexOf("trident") !== -1 || browse.indexOf("msie") !== -1) {
          anchor.scrollIntoView();
          window.scrollTo(0, anchor.offsetTop - 80);
        } else {
          window.scrollTo({ top: anchor.offsetTop - 80, behavior: "smooth" });
        }

        setTimeout(function () {
          throttledScroll();
        }, 1);
      }
      //window.scrollBy(0, -80);
    }
  }

  function findPosition() {
    let id = [];
    // props.data.map((item, index) => {
    //   id[index] = item.id;
    // });
    // for (let i = 0; i < props.data.length; i++) {
    //   id[i] = props.data[i].id;
    // }
    const el = document.querySelectorAll(".manual-item");
    el.forEach((item, index) => {
      id[index] = item;
    });

    idList = id.filter((element, i) => element !== null);
    idList = idList.filter((element, i) => element !== "");
    //console.log("idList :", idList);

    let obj;

    for (let i = 0; i < idList.length; i++) {
      // obj = document.getElementById(idList[i]);
      obj = idList[i];

      //posY = window.scrollY + obj.getBoundingClientRect().top();

      if (obj) {
        idPosition[i] = obj.offsetTop;
      }
      // console.log( idList[i], " : ", obj.offsetTop );
    }

    // let active = idList[0];
    // setActiveId(active);

    //console.log(idList);
    //console.log(idPosition);
  }
  const throttledScroll = useMemo(
    () =>
      throttle(() => {
        findPosition();
        //var scrollPosition = window.scrollY || document.documentElement.scrollTop;
        var scrollPosition = window.scrollY || window.pageYOffset;

        // setScrollY(scrollPosition);
        // console.log("y : ", scrollPosition);
        // console.log("y2 : ", window.pageYOffset);

        // for(let i = 0; i < idPosition.length; i++) {
        //   if((Number(idPosition[i])-30) < window.scrollY && (Number(idPosition[i+1])-30) < window.scrollY) {
        //     let temp = idList[i];
        //     setActiveId(temp);
        //     //console.log("Active Id :", temp);
        //   }
        // }

        let temp;

        if (scrollPosition < Number(idPosition[0])) {
          temp = idList[0].textContent;
          setActiveId(temp);
        }
        for (let i = 0; i < idPosition.length; i++) {
          if (
            idPosition[i] - 100 < scrollPosition &&
            // scrollPosition < idPosition[i + 1] &&
            i <= idPosition.length - 1
          ) {
            temp = idList[i].textContent;
            setActiveId(temp);
          }
        }

        if (idPosition[idPosition.length - 1] - 100 < scrollPosition) {
          temp = idList[idList.length - 1].textContent;
        }
      }, 1),
    // eslint-disable-next-line
    [props]
  );

  useEffect(() => {
    findPosition();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (props?.hash) {
      scrollToHash(props.hash);
    }
  }, [props.hash]);

  // useEffect(() => {
  //   console.log("active id :", ActiveId);

  // }, [ActiveId]);

  useEffect(() => {
    window.addEventListener("scroll", throttledScroll);

    return () => {
      window.removeEventListener("scroll", throttledScroll);
    };
  }, [throttledScroll]);

  // useEffect(() => {
  //   if (props.data.length !== 0) {
  //     setShortCutData(props.data);
  //   }
  // }, [props.data]);

  // useEffect(() => {
  //   const temp = [];
  //   shortCutData?.forEach((item, index) => {
  //     temp[index] = item.textContent;
  //   });
  //   setShortCutList(temp);
  // }, [shortCutData]);

  // useEffect(() => {
  //   console.log(shortCutList);
  // }, [shortCutList]);
  useEffect(() => {
    const objectValue = props.data?.map((item) => ({
      id: item,
      title: item,
    }));
    setShortCutData(objectValue);
  }, [props]);

  // useEffect(() => {
  //   async function updateShortCutList() {
  //     const temp = [];
  //     for (const item of shortCutData) {
  //       const content = await getContent(item);
  //       temp.push(content);
  //     }
  //     setShortCutList(temp);
  //     return temp;
  //   }
  //   updateShortCutList();
  // }, [shortCutData]);

  // async function getContent(item) {
  //   return new Promise((resolve) => {
  //     const content = item.textContent;
  //     resolve(content);
  //   });
  // }

  return (
    <>
      <div className="component-shortcutdiv shortcut">
        <ul
          className="component-ul"
          style={
            props.height !== undefined && props.height === true
              ? { top: "300px" }
              : {}
          }
        >
          {shortCutData?.map((item, index) => {
            return (
              item.title && (
                <li
                  className={
                    "component-li" +
                    (ActiveId === item.title ? " component-li-active" : "")
                  }
                  onClick={() => {
                    scrollToHash(item.id);
                  }}
                  // isActive={ActiveId === item.title ? true : false}
                  key={index}
                >
                  <div
                    className={
                      "component-item" +
                      (ActiveId === item.title ? " component-item-active" : "")
                    }
                    // isActive={ActiveId === item.title ? true : false}
                  >
                    {item.title}
                  </div>
                </li>
              )
            );
          })}
        </ul>
      </div>
    </>
  );
}
